import React from 'react';

const Header = () => {
  return (
    <header style={styles.header}>
      {/* Left Logo */}
      <div style={styles.logo}>
        <img src="ossat.png" alt="Left Logo" style={styles.logoImage} />
      </div>

      {/* Center Title */}
      <div style={styles.title}>
       {/* <h2>Welcome to Social Audit Portal of Jajpur</h2>*/}
        <h2 style={styles.titleHeading}>District Social Audit Unit, Balasore</h2>
        <p style={styles.titleSubheading}>(Under OSSAAT)</p>
        <h6 style={styles.titleSubheading}>PR & DW Dept. Government Of Odisha,Bhubaneswar</h6>
      </div>

      {/* Right Logo */}
      <div style={styles.logo}>
        <img src="logo.png" alt="Right Logo" style={styles.logoImage} />
      </div>
    </header>
  );
};

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between', // Distribute space between left, center, and right
    alignItems: 'center',
    padding: '10px 2%',
    backgroundColor: 'white', // Dark blue background
    boxShadow: '0 4px 2px -2px gray',
    overflow:"hidden",
  },
  logo: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoImage: {
    width: 'clamp(40px ,8vw, 70px)',  // Adjust the size of the logo
    height: 'auto', // Adjust the size of the logo
    
  },
  title: {
    flex: '1 1 auto',
    textAlign: 'center',
    color: 'black', // Light text color for the title
    overflow:'hiden',
  },
  titleHeading: {
    margin: '5px 0', // Reduce vertical margin
    fontSize: 'clamp(16px, 2vw, 28px)', // Customize font size
    whiteSpace:'nowarp',
  },
  titleSubheading: {
    margin: '0', // Remove additional spacing
    fontSize: 'clamp(12px, 1.5vw, 18px)', // Customize font size
     whiteSpace:'nowarp',
  },
  titleSmallText: {
    margin: '2px 0', // Minimizes gaps between <h6> and others
    fontSize: 'clamp(10px, 1.2vw, 16px)', // Makes <h6> smaller for better hierarchy
     whiteSpace:'nowarp',
  },

  
};

export default Header;
